import configProvider from './configProvider';

/**
 * @ngdoc module
 * @name mcb.core.config
 */
export default angular
  .module('mcb.core.config', [])
  .provider('mcbConfig', configProvider);
